export var NavigationTypes;
(function (NavigationTypes) {
    NavigationTypes["WAZE"] = "waze";
    NavigationTypes["GOOGLE"] = "google";
    NavigationTypes["APPLE"] = "apple";
})(NavigationTypes || (NavigationTypes = {}));
